// extracted by mini-css-extract-plugin
module.exports = {"container":"_2IaR_","downloadText":"_1QhSI","download":"_1HiuC","linkWeight":"_2S_Kh","icon":"_3nQ_K"};